import * as tslib_1 from "tslib";
import React from 'react';
import { findDOMNode } from 'react-dom';
import keycode from 'keycode';
import contains from 'dom-helpers/query/contains';
import activeElement from 'dom-helpers/activeElement';
import ownerDocument from 'dom-helpers/ownerDocument';
import List from './List';
var MenuList = /** @class */ (function (_super) {
    tslib_1.__extends(MenuList, _super);
    function MenuList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentTabIndex: -1,
        };
        _this.selectedItemIndex = -1;
        _this.handleList = function () {
            if (_this.list) {
                var list = findDOMNode(_this.list);
                _this.resetTabIndex();
            }
        };
        _this.handleBlur = function (event) {
            _this.blurTimer = setTimeout(_this.handleList, 30);
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };
        _this.handleKeyDown = function (event) {
            var key = keycode(event.nativeEvent);
            var focusItem = _this.getFocusItem();
            if (!focusItem) {
                return;
            }
            if (key === 'down') {
                event.preventDefault();
                if (focusItem.nextElementSibling) {
                    focusItem.nextElementSibling.focus();
                }
            }
            else if (key === 'up') {
                event.preventDefault();
                if (focusItem.previousElementSibling) {
                    focusItem.previousElementSibling.focus();
                }
            }
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(event, key);
            }
        };
        _this.handleItemFocus = function (event) {
            var list = findDOMNode(_this.list);
            if (list) {
                for (var i = 0; i < list.children.length; i += 1) {
                    if (list.children[i] === event.currentTarget) {
                        _this.setTabIndex(i);
                        break;
                    }
                }
            }
        };
        return _this;
    }
    MenuList.prototype.componentDidMount = function () {
        this.resetTabIndex(true);
    };
    MenuList.prototype.componentWillUnmount = function () {
        clearTimeout(this.blurTimer);
    };
    Object.defineProperty(MenuList.prototype, "items", {
        get: function () {
            return Array.from(findDOMNode(this.list).children);
        },
        enumerable: true,
        configurable: true
    });
    MenuList.prototype.setTabIndex = function (index) {
        this.setState({ currentTabIndex: index });
    };
    MenuList.prototype.getFocusItemIndex = function () {
        var focusItem = this.getFocusItem();
        if (focusItem) {
            return this.items.indexOf(focusItem);
        }
        return -1;
    };
    MenuList.prototype.getFocusItem = function () {
        var list = findDOMNode(this.list);
        var currentFocus = activeElement(ownerDocument(list));
        if (list && contains(list, currentFocus)) {
            return currentFocus;
        }
        return null;
    };
    MenuList.prototype.focus = function () {
        var currentTabIndex = this.state.currentTabIndex;
        var list = findDOMNode(this.list);
        if (!list || !list.children || !list.firstChild) {
            return;
        }
        if (currentTabIndex >= 0) {
            list.children[currentTabIndex].focus();
        }
        else {
            list.firstChild.focus();
        }
    };
    MenuList.prototype.resetTabIndex = function (forceReset) {
        var currentFocusIndex = this.getFocusItemIndex();
        if (!forceReset && currentFocusIndex) {
            return;
        }
        if (currentFocusIndex !== -1) {
            this.setTabIndex(currentFocusIndex);
        }
        else if (this.selectedItemIndex !== -1) {
            this.setTabIndex(this.selectedItemIndex);
        }
        else {
            this.setTabIndex(0);
        }
    };
    Object.defineProperty(MenuList.prototype, "selectedItem", {
        get: function () {
            if (this.selectedItemIndex !== -1) {
                var list = findDOMNode(this.list);
                if (list) {
                    return list.children[this.selectedItemIndex];
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuList.prototype, "containsSelectedItem", {
        get: function () {
            return this.selectedItemIndex !== -1;
        },
        enumerable: true,
        configurable: true
    });
    MenuList.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, other = tslib_1.__rest(_a, ["children"]);
        this.selectedItemIndex = -1;
        return (React.createElement(List, tslib_1.__assign({ role: "menu", innerRef: function (node) {
                _this.list = node;
            }, onBlur: this.handleBlur }, other), React.Children.map(children, function (child, index) {
            if (!React.isValidElement(child)) {
                return null;
            }
            var childProps = {
                key: child.props.key || index,
                tabIndex: index === _this.state.currentTabIndex ? 0 : -1,
                onFocus: _this.handleItemFocus,
                onKeyDown: _this.handleKeyDown,
            };
            var element = React.cloneElement(child, childProps);
            if (child.props.selected) {
                _this.selectedItemIndex = index;
            }
            return element;
        })));
    };
    return MenuList;
}(React.Component));
export default MenuList;
export { MenuList };
//# sourceMappingURL=MenuList.js.map